'use es6';

import { getTopLevelType } from '../../common-message-format/operators/commonMessageFormatGetters';
import { CRM_SIDEBAR_UPDATE } from '../constants/messageTypes';
export const isCrmSidebarUpdateMessage = message => getTopLevelType(message) === CRM_SIDEBAR_UPDATE;